import React from "react";
import cx from "classnames";
import { ValidationMessage } from "@components/validationMessage"
import ToolTipIcon from "../toolTipIcon"
import Wrapper from "./input.styles";
import { isNotNullOrEmpty } from "@src/utils/helpers/stringHelper";

export const Input = React.forwardRef((props, ref) => {
  const {
    title,
    prefix,
    suffix,
    errorMessage,
    toolTipText,
    OptionalLabel,
    optional,
    type,
    onChange,
    customClass,
    value,
    disabled,
    ...rest
  } = props;

  let inputClasses = "textBox";
  if(customClass) {
    inputClasses = inputClasses + " " + customClass;
  }

  return (
    <Wrapper>
      <div className={inputClasses}>
        <div className="textBox-Label-Container">
          {title && (
            <label className={cx("textBox-Label", { error: isNotNullOrEmpty(errorMessage) })}>
              {title}
              {!!toolTipText && (
                <ToolTipIcon toolTipText={toolTipText} />
              )}
              {OptionalLabel && (
                <label className="textBox-Label-Optional">optional</label>
              )}
            </label>
          )}
        </div>
        <div className={`textBox-Input ${errorMessage ? "required" : ""}`}>
          {prefix && (
            <div
              className={`textBox-Icon ${errorMessage ? "iconRequired" : ""} `}
            >
              {prefix}
            </div>
          )}
          {(() => {
            if (type === "number") {
              return (
                <input
                  {...rest}
                  ref={ref}
                  type="text"
                  value={value || ""}
                  onChange={onChange}
                  onKeyPress={evt => {
                    if (evt.which !== 13 && (evt.which < 48 || evt.which > 57)) {
                      evt.preventDefault();
                    }
                  }}
                  disabled={disabled}
                />
              );
            } else {
              return <input {...rest} value={value || ""} type={type} onChange={onChange} disabled={disabled}/>;
            }
          })()}
          {suffix && (
            <div
              className={`textBox-Icon-Suffix ${
                errorMessage ? "iconRequired" : ""
              } `}
            >
              {suffix}
            </div>
          )}
        </div>
        <ValidationMessage errorMessage={errorMessage} />
      </div>
    </Wrapper>
  );
});

export default Input;
